import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslator } from 'tradera-lang/translate';
import ImageTags from '../tags/image-tags';
import { fetchTrendingBrandsIfNeeded } from 'tradera-state/views/start-page/actions';

const TrendingBrandsTags = () => {
    const { t } = useTranslator();
    const dispatch = useDispatch();

    const tags = useSelector(
        state => state.views.startPage.trendingBrands.items
    );

    useEffect(() => {
        dispatch(fetchTrendingBrandsIfNeeded());
    }, [dispatch]);

    if (!tags || tags.length === 0) {
        return null;
    }

    return (
        <>
            <h3 className="start-page-section-title">
                {t('trendingTags_brands')}
            </h3>
            <ImageTags gaCategory="Trending Brands" tags={tags} />
        </>
    );
};

export default TrendingBrandsTags;
